import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProvinciaService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(`/Provincia`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/Provincia/${id}`,
    ).pipe(
      map(response => response)
    );
  }
}
